export default __webpack_public_path__ + "04f5bc774d44b73ca45e5a85db8bf88b.glb";